import { IFilterElement } from "@saleor/components/Filter";
import {
  InstagramFilterKeys,
  InstagramListFilterOpts
} from "@saleor/instagram/components/InstagramListPage/filters";
import {
  InstagramListUrlFilters,
  InstagramListUrlFiltersEnum,
  InstagramListUrlFiltersWithMultipleValuesEnum,
  InstagramListUrlQueryParams
} from "@saleor/instagram/urls";
import { findInEnum, findValueInEnum, maybe, parseBoolean } from "@saleor/misc";
import {
  ContentPlatformEnum,
  InstagramTypeFilterInput
} from "@saleor/types/globalTypes";
import {
  createFilterTabUtils,
  createFilterUtils,
  dedupeFilter,
  getGteLteVariables,
  getMinMaxQueryParam,
  getMultipleEnumValueQueryParam,
  getSingleValueQueryParam
} from "@saleor/utils/filters";

export const ATTRIBUTE_FILTERS_KEY = "instagramFilters";

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<InstagramListUrlFilters>(ATTRIBUTE_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  InstagramListUrlQueryParams,
  InstagramListUrlFilters
>(InstagramListUrlFiltersEnum);

export function getFilterQueryParam(
  filter: IFilterElement<InstagramFilterKeys>
): InstagramListUrlFilters {
  const { name } = filter;
  switch (name) {
    case InstagramFilterKeys.createTime:
      return getMinMaxQueryParam(
        filter,
        InstagramListUrlFiltersEnum.createdFrom,
        InstagramListUrlFiltersEnum.createdTo
      );
    case InstagramFilterKeys.published:
      return getSingleValueQueryParam(
        filter,
        InstagramListUrlFiltersEnum.published
      );
    case InstagramFilterKeys.platForm:
      return getMultipleEnumValueQueryParam(
        filter,
        InstagramListUrlFiltersWithMultipleValuesEnum.platForm,
        ContentPlatformEnum
      );
  }
}

export function getFilterVariables(
  params: InstagramListUrlFilters
): InstagramTypeFilterInput {
  return {
    createTime: getGteLteVariables({
      gte: params.createdFrom,
      lte: params.createdTo
    }),
    published:
      params.published !== undefined
        ? parseBoolean(params.published, false)
        : undefined,
    platForm: maybe(() =>
      params.platForm.map(paymentStatus =>
        findInEnum(paymentStatus, ContentPlatformEnum)
      )
    ),
    search: params.query
  };
}

export function getFilterOpts(
  params: InstagramListUrlFilters
): InstagramListFilterOpts {
  return {
    published: {
      active: params.published !== undefined,
      value: maybe(() => parseBoolean(params.published, true))
    },
    createTime: {
      active: maybe(
        () =>
          [params.createdFrom, params.createdTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.createdTo, ""),
        min: maybe(() => params.createdFrom, "")
      }
    },
    platForm: {
      active: maybe(() => params.platForm !== undefined, false),
      value: maybe(
        () =>
          dedupeFilter(
            params.platForm.map(status =>
              findValueInEnum(status, ContentPlatformEnum)
            )
          ),
        []
      )
    }
  };
}
